//Library modul
import { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";

//Redux function
import { edit_properties_upload } from "../../App/actions/layerActions";

//Picture Asset
import icon_download from "../../Assets/svg/icon_import.svg";
import icon_upload from "../../Assets/svg/icon_upload.svg";

//General Function
import uuid from "../../App/validation/uuid";
import { getGeoLayer } from "../../App/reduxHelper/layer";
import dict from "../../Data/dict.json";

const language = localStorage?.language ? localStorage?.language : "ina";

const Document = ({ params, layer_id, layer, edit_properties_upload }) => {
  const [document, set_document] = useState("");
  const fileInput = useRef(null);

  const feature_key = params?.row?.key;
  const properties_key = params?.field;

  useEffect(() => {
    const value = params?.value;
    if (typeof value === "string" && isNaN(value)) {
      set_document(value);
    }
  }, [params?.value]);

  const handle_submit = async (e) => {
    e.preventDefault();
    const file = fileInput.current?.files[0];

    if (!file) return;

    const body_file = {
      file: file,
      file_name: `doc_%${file?.name}_%${uuid()}`,
      dirname: "properties",
    };

    const body_database = {
      geo_layer_id: layer_id,
      feature_key: feature_key,
      properties_key: properties_key,
      properties_value: "", //boleh dikosongkan karena akan ditimpa dengan url dengan methode edit_properties_upload
    };

    const body = {
      body_file,
      body_database,
      mode: "file",
    };

    const result = await edit_properties_upload(
      body,
      getGeoLayer(layer)?.architecture,
      layer_id,
      params?.row?.nested_attributes ? params : undefined,
    );

    set_document(result?.properties_value);
  };

  const fileNameOnServer = document?.split("/")?.at(-1);
  const arrayName = fileNameOnServer?.split("_%25");
  const extension = fileNameOnServer?.split(".")?.at(-1);
  const originalName =
    arrayName?.at(0)?.split("_")?.at(1) === "doc"
      ? arrayName?.at(1)?.replaceAll("%20", " ") +
        (extension ? `.${extension}` : "")
      : "";

  return (
    <section
      style={{
        height: "100%",
        width: "100%",
        padding: 5,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
      title="Only for jpg, png, pdf, zip, and rar extensions"
    >
      <label className="fileContainer">
        <div
          className="button_small hover_bigger"
          style={{
            display: "flex",
            alignItems: "center",
            fontSize: "10px",
            width: 15,
            height: 15,
            backgroundColor: "#e6eef3",
            padding: "5px",
            border: "1px solid #9ca8bb",
            borderRadius: "99px",
          }}
        >
          <img src={icon_upload} className="h_15 w_15 rounded" alt="upload" />
          {/* {dict["Upload file"][language]} */}
        </div>
        <input
          id={`${feature_key}-${properties_key}`}
          style={{ display: "none" }}
          type="file"
          accept="file/*"
          ref={fileInput}
          onChange={handle_submit}
        />
      </label>

      {document ? (
        <div className="flex gap_5 h_2">
          <div title={originalName} className="w_150 center_perfect">
            <p className="truncate">{originalName}</p>
          </div>
          <a
            className="hover_darkGreen hover_bigger pointer"
            style={{
              display: "flex",
              alignItems: "center",
              fontSize: "10px",
              width: 15,
              height: 15,
              backgroundColor: "#e6eef3",
              padding: "5px",
              border: "1px solid #9ca8bb",
              borderRadius: "99px",
            }}
            target="_blank"
            rel="noreferrer noopener"
            href={document}
            id={`${feature_key}-${properties_key}-download`}
          >
            <img
              alt="download"
              src={icon_download}
              className="h_15 w_15 rounded"
            />
          </a>
        </div>
      ) : (
        <div
          style={{
            fontSize: "10px",
            width: 80,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginLeft: 5,
          }}
        >
          {dict["No document"][language]}
        </div>
      )}
    </section>
  );
};

const mapStateToProps = (state) => ({
  layer: state.layer,
});

export default connect(mapStateToProps, {
  edit_properties_upload,
})(Document);
